import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class DocumentAiDataService<T = unknown> {
	private dataSubject: ReplaySubject<T> = new ReplaySubject<T>(null);

	private jumpToSectionSubject: ReplaySubject<string> =
		new ReplaySubject<string>(1);

	setData(data: T): void {
		this.dataSubject.next(data);
	}

	getData$(): Observable<T> {
		return this.dataSubject.asObservable();
	}

	jumpToSection(section: string): void {
		this.jumpToSectionSubject.next(section);
	}

	jumpToSection$(): Observable<string> {
		return this.jumpToSectionSubject.asObservable();
	}
}
